import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Card, CardBody, CardHeader, Container } from "reactstrap";

import Header from "../../../components/Headers/Header";
import { ISelectedFilters } from "../../../types";
import Filter from "../Components/Filter/Filter";
import CustomTable from "../../../components/Tables/CustomTable";
import ConfirmModal from "../../../components/Modals/ConfirmModal";
import HeaderWithDownload from "../../../components/HeaderWithDownload";

export default function AverageAppUsageForStudent() {
  const session = useSelector((state: any) => state.user.session);
  const [showFilterAlert, setShowFilterAlert] = useState<boolean>(false);
  const [selectedFilters, setSelectedFilters] = useState<ISelectedFilters>();
  const [selectedFilterForReport, setSelectedFilterForReport] =
    useState<ISelectedFilters>();
  return (
    <React.Fragment>
      <Header />
      <ConfirmModal
        isOpen={showFilterAlert}
        onClose={() => setShowFilterAlert((prev) => !prev)}
        type={"warning"}
        title={`Data size will be too large.`}
        subtitle="Please select filters for district & block"
        hideCancelButton
        onConfirm={() => {
          setShowFilterAlert(false);
        }}
      />
      <Container className="mt-n7" fluid>
        <Card className="mb-4 mb-xl-0">
          <CardHeader className="border-0">
            <HeaderWithDownload
              title="Avg. App Usage for
                Student"
              reportType="appUsage"
              selectedFilters={selectedFilterForReport}
            />
            <Filter
              hasDistrictFilter
              hasBlockFilter
              hasSchoolFilter
              hasGradeFilter
              hasDateFilter
              onSearch={(value) => {
                setSelectedFilters(value);
              }}
              onClear={() => {
                setSelectedFilters(undefined);
              }}
              onFilterChange={(value) => {
                setSelectedFilterForReport(value);
              }}
            />
          </CardHeader>
          <CardBody>
            <CustomTable
              url={`custom/stats_admin/student/appUsage?grade_id=${
                selectedFilters?.gradeId || -1
              }&student_id=-1&grade_section_id=-1&district=${
                selectedFilters?.districtId || -1
              }&block=${selectedFilters?.blockId || -1}&school=${
                selectedFilters?.schoolId || -1
              }&start_date=${
                selectedFilters?.date?.start_date || -1
              }&end_date=${
                selectedFilters?.date?.end_date || -1
              }&limit=${10}&session=${session?.id}`}
              column={[
                { key: "id", label: "ID" },
                { key: "srn_no", label: "SRN No." },
                { key: "first_name", label: "First name" },
                { key: "last_name", label: "Last name" },
                { key: "grade", label: "Grade" },
                { key: "section", label: "Section" },
                { key: "school", label: "School" },
                { key: "district", label: "District" },
              ]}
              tableTitle={""}
              searchBox={false}
              itemsLimit={10}
              customFunction={() => {}}
              customColumns={[
                {
                  heading: "Usage (HH:mm)",
                  renderer: (each: any) => {
                    let h = String(Math.floor(+each?.usage_min / 60));
                    h = h.length === 1 ? `0${h}` : h;
                    let m = String(each?.usage_min % 60);
                    m = m.length === 1 ? `0${m}` : m;
                    return <span>{`${h}:${m}`}</span>;
                  },
                },
              ]}
            />
          </CardBody>
        </Card>
      </Container>
    </React.Fragment>
  );
}
